var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Divider, LILAC_300, WHITE, checkIsPlatform, getTestId, isValidObject, tokens } from '@airtel/air-design-system';
import { useCallback, useEffect, useRef, useState } from 'react';
import { FlatList, View } from 'react-native';
import { AddOnWidget } from '../add-on-widget';
import { LinkListItemWidget } from '../link-list-item-widget';
import { OrderSummaryCardWidget } from '../order-summary-card-widget';
import { getDynamicScrollListWidgetStyles } from './DynamicScrollListWidgetStyles';
import GridScrollList from './components/grid-scroll-list';
import TitleAndBanner from './components/title-and-banner/TitleAndBanner';
var listOfAllComponent = {
  AirOrderSummaryCardWidget: OrderSummaryCardWidget,
  AirLinkListItemWidget: LinkListItemWidget,
  AirAddOnWidget: AddOnWidget
};
export var DynamicScrollListWidgetComponent = props => {
  var widgetGenericRendererKey = props.widgetGenericRendererKey,
    _props$showItemSepara = props.showItemSeparator,
    showItemSeparator = _props$showItemSepara === void 0 ? true : _props$showItemSepara,
    _props$pageSize = props.pageSize,
    pageSize = _props$pageSize === void 0 ? 10 : _props$pageSize,
    title = props.title,
    infoTagProps = props.infoTagProps,
    id = props.id,
    _props$data = props.data,
    data = _props$data === void 0 ? [] : _props$data,
    _props$separatorSpace = props.separatorSpace,
    separatorSpace = _props$separatorSpace === void 0 ? 2 : _props$separatorSpace,
    separatorColor = props.separatorColor,
    _props$numberOfColumn = props.numberOfColumn,
    numberOfColumn = _props$numberOfColumn === void 0 ? 1 : _props$numberOfColumn,
    _props$isHorizontalSc = props.isHorizontalScroll,
    isHorizontalScroll = _props$isHorizontalSc === void 0 ? false : _props$isHorizontalSc,
    _props$isHorizontalWi = props.isHorizontalWithoutScroll,
    isHorizontalWithoutScroll = _props$isHorizontalWi === void 0 ? false : _props$isHorizontalWi,
    isGridView = props.isGridView,
    onUserAction = props.onUserAction,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'DynamicScrollListWidget' : _props$testID,
    style = props.style,
    showCard = props.showCard,
    showCallout = props.showCallout,
    showShadow = props.showShadow,
    calloutWidgetProps = props.calloutWidgetProps,
    onCardPressMetaData = props.onCardPressMetaData,
    _props$isSelectable = props.isSelectable,
    isSelectable = _props$isSelectable === void 0 ? false : _props$isSelectable,
    _props$selectableType = props.selectableType,
    selectableType = _props$selectableType === void 0 ? 'single' : _props$selectableType,
    _props$selectableData = props.selectableData,
    selectableData = _props$selectableData === void 0 ? {} : _props$selectableData,
    _props$enableLazyLoad = props.enableLazyLoading,
    enableLazyLoading = _props$enableLazyLoad === void 0 ? true : _props$enableLazyLoad,
    listContainerStyle = props.listContainerStyle,
    listItemContainerStyle = props.listItemContainerStyle,
    restProps = __rest(props, ["widgetGenericRendererKey", "showItemSeparator", "pageSize", "title", "infoTagProps", "id", "data", "separatorSpace", "separatorColor", "numberOfColumn", "isHorizontalScroll", "isHorizontalWithoutScroll", "isGridView", "onUserAction", "testID", "style", "showCard", "showCallout", "showShadow", "calloutWidgetProps", "onCardPressMetaData", "isSelectable", "selectableType", "selectableData", "enableLazyLoading", "listContainerStyle", "listItemContainerStyle"]);
  var setOfVisitedIds = useRef(new Set());
  var _useState = useState({}),
    selectedState = _useState[0],
    setSelectedState = _useState[1];
  var _useState2 = useState(null),
    flatListWidth = _useState2[0],
    setFlatListWidth = _useState2[1];
  var dynamicScrollListWidgetStyles = getDynamicScrollListWidgetStyles(props, flatListWidth);
  useEffect(() => {
    if (isSelectable && isValidObject(selectableData)) {
      setSelectedState(prevState => {
        var index = selectableData === null || selectableData === void 0 ? void 0 : selectableData.index;
        var value = !(prevState === null || prevState === void 0 ? void 0 : prevState[index]);
        if (selectableType === 'multi') {
          return Object.assign(Object.assign({}, prevState), {
            [index]: value
          });
        } else {
          return {
            [index]: value
          };
        }
      });
    }
  }, [selectableData]);
  var renderDynamicListItem = _ref => {
    var _ref$item = _ref.item,
      item = _ref$item === void 0 ? {} : _ref$item,
      index = _ref.index;
    var ComponentToRender = Object.values(listOfAllComponent).find(componentValue => componentValue.genericRendererKey === widgetGenericRendererKey);
    return _jsx(View, Object.assign({
      style: [isHorizontalScroll && flatListWidth && {
        width: dynamicScrollListWidgetStyles.singleListItemWidth.width
      }, listItemContainerStyle]
    }, {
      children: _jsx(ComponentToRender, Object.assign({}, item, {
        onCardPressMetaData: (item === null || item === void 0 ? void 0 : item.onCardPressMetaData) || onCardPressMetaData,
        onUserAction: onUserAction
      }, isSelectable && {
        [selectableData === null || selectableData === void 0 ? void 0 : selectableData.key]: selectedState === null || selectedState === void 0 ? void 0 : selectedState[index]
      }, {
        style: [item.style, {
          borderRadius: showCard ? tokens.spacing.SPACING_16 : tokens.spacing.SPACING_0
        }]
      }, getTestId(testID + '_' + (index !== null && index !== void 0 ? index : 0).toString(), ComponentToRender === null || ComponentToRender === void 0 ? void 0 : ComponentToRender.genericRendererKey)))
    }));
  };
  var onViewableItemsChanged = useCallback(info => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    for (var i = 0; i < ((_a = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _a === void 0 ? void 0 : _a.length); i++) {
      var sendImpression = checkIsPlatform('web') && !((_b = setOfVisitedIds === null || setOfVisitedIds === void 0 ? void 0 : setOfVisitedIds.current) === null || _b === void 0 ? void 0 : _b.has((_c = info === null || info === void 0 ? void 0 : info.viewableItems[i]) === null || _c === void 0 ? void 0 : _c.index));
      if (((_e = (_d = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _d === void 0 ? void 0 : _d[i]) === null || _e === void 0 ? void 0 : _e.index) != null) {
        sendImpression && ((_f = setOfVisitedIds === null || setOfVisitedIds === void 0 ? void 0 : setOfVisitedIds.current) === null || _f === void 0 ? void 0 : _f.add((_g = info === null || info === void 0 ? void 0 : info.viewableItems[i]) === null || _g === void 0 ? void 0 : _g.index));
        ((_j = (_h = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _h === void 0 ? void 0 : _h[i].item) === null || _j === void 0 ? void 0 : _j.onItemImpression) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, (_l = (_k = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _k === void 0 ? void 0 : _k[i].item) === null || _l === void 0 ? void 0 : _l.onItemImpression), (_m = info === null || info === void 0 ? void 0 : info.viewableItems[i]) === null || _m === void 0 ? void 0 : _m.item));
      }
    }
  }, []);
  var renderFlatListWithoutCard = () => {
    return _jsxs(_Fragment, {
      children: [_jsx(TitleAndBanner, Object.assign({
        title: title,
        infoTagProps: infoTagProps,
        showCallout: showCallout,
        calloutWidgetProps: calloutWidgetProps,
        onUserAction: onUserAction
      }, getTestId(testID, 'TitleAndBanner'))), isHorizontalWithoutScroll ? _jsx(View, Object.assign({
        style: [dynamicScrollListWidgetStyles.listContainer, listContainerStyle]
      }, {
        children: data === null || data === void 0 ? void 0 : data.map(function (item, index) {
          if (item === void 0) {
            item = {};
          }
          return renderDynamicListItem({
            item,
            index
          });
        })
      })) : _jsx(FlatList, Object.assign({
        onLayout: _ref2 => {
          var nativeEvent = _ref2.nativeEvent;
          var _a;
          if (!isGridView && ((_a = nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.layout) === null || _a === void 0 ? void 0 : _a.width)) {
            setFlatListWidth(nativeEvent.layout.width);
          }
        },
        data: data,
        contentContainerStyle: dynamicScrollListWidgetStyles.contentContainer,
        horizontal: isHorizontalScroll,
        renderItem: renderDynamicListItem,
        keyExtractor: (_, index) => "list_item_item_" + index,
        ItemSeparatorComponent: () => showItemSeparator && (showCard ? _jsx(Divider, {
          color: LILAC_300,
          shadowColor: WHITE,
          height: tokens.spacing.SPACING_2
        }) : _jsx(View, {
          style: {
            width: isHorizontalScroll ? separatorSpace : '100%',
            height: isHorizontalScroll ? '100%' : separatorSpace,
            backgroundColor: separatorColor
          }
        })),
        onViewableItemsChanged: onViewableItemsChanged,
        showsHorizontalScrollIndicator: false,
        style: [style]
      }, getTestId(testID, 'list')))]
    });
  };
  return _jsx(View, Object.assign({}, getTestId(testID), {
    children: (data === null || data === void 0 ? void 0 : data.length) > 0 && (isGridView ? _jsx(GridScrollList, Object.assign({
      title: title,
      infoTagProps: infoTagProps,
      showCallout: showCallout,
      calloutWidgetProps: calloutWidgetProps,
      onUserAction: onUserAction,
      pageSize: pageSize,
      data: data,
      renderDynamicListItem: renderDynamicListItem,
      separatorSpace: separatorSpace,
      numberOfColumn: numberOfColumn,
      isHorizontalScroll: isHorizontalScroll,
      enableLazyLoading: enableLazyLoading
    }, getTestId(testID, 'gridScrollList'))) : showCard ? _jsx(Card, Object.assign({}, restProps, {
      showShadow: showShadow
    }, getTestId(testID, 'listWithCard'), {
      children: renderFlatListWithoutCard()
    })) : renderFlatListWithoutCard())
  }));
};
DynamicScrollListWidgetComponent.genericRendererKey = 'AirDynamicScrollListWidget';